<template>
  <v-container>
    <div class="text-center title ma-2 mt-4">
      {{ location.address }}
    </div>
    <div class="text-center overline">
      Lat: {{ location.lat | formatLatLng }} - Lng:
      {{ location.lng | formatLatLng }}
    </div>
    <v-container class="map fill-height" max-height="800">
      <l-map ref="map" v-resize="onResize" :zoom="16" :center="marker">
        <l-control-layers />

        <l-tile-layer
          v-for="provider in tileProviders"
          :key="provider.id"
          :name="provider.name"
          :url="provider.url"
          layer-type="base"
        />
        <l-marker :lat-lng="marker"></l-marker>
      </l-map>
    </v-container>
  </v-container>
</template>

<script>
import { LMap, LTileLayer, LControlLayers, LMarker } from 'vue2-leaflet'

export default {
  name: 'SingleImmo',
  props: ['location'],
  components: { LMap, LTileLayer, LControlLayers, LMarker },
  data() {
    return {
      tileProviders: [
        {
          id: 1,
          name: 'Open Street Map',
          url: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',
          attribution: 'OSM'
        },
        {
          id: 2,
          name: 'cartocdn',
          url:
            'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
          attribution:
            "&copy; <a href='http://www.openstreetmap.org/copyright'>OpenStreetMap</a> &copy; <a href='https://carto.com/attributions'>CARTO</a>"
        },
        {
          id: 3,
          name: 'Esri World Map',
          url:
            'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
          attribution: 'Esri'
        },
        {
          id: 4,
          name: 'Esri World Imagery',
          url:
            'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
          attribution: 'Esri'
        }
      ],
      bounds: null
    }
  },

  computed: {
    marker() {
      return [this.location.lat || 0.0, this.location.lng || 0.0]
    }
  },

  methods: {
    onResize() {
      this.$refs.map.mapObject.invalidateSize()
    }
  }
}
</script>

<style lang="scss">
.map {
  height: 800px;
}
</style>
